import React, { useCallback, useMemo } from 'react';
import { Modal, Button } from '@mantine/core';
import { FetchResult } from '@apollo/client';

type Props = {
    opened: boolean;
    subject?: string;
    message?: string;
    loading?: boolean;
    onConfirm: () => void | Promise<void> | Promise<FetchResult>;
    close: () => void;
};

function ConfirmDeleteModal({
    opened,
    close,
    onConfirm,
    subject,
    message,
    loading,
}: Props) {
    const title = useMemo(() => {
        if (subject) {
            return `Delete ${subject}?`;
        }

        return 'Delete';
    }, [subject]);

    const messageBody = useCallback(() => {
        if (message) {
            return message;
        }
        if (subject) {
            return <p>Are you sure you want to delete this {subject}</p>;
        }
        return 'Are you sure you want to delete this item?';
    }, [message, subject]);

    const handleConfirm = useCallback(async () => {
        await onConfirm();
        close();
    }, [onConfirm, close]);

    return (
        <Modal
            title={title}
            opened={opened}
            onClose={close}
            size="lg"
            centered
            keepMounted={false}
            classNames={{
                title: 'font-semibold text-lg',
            }}
        >
            <div className="p-3">
                <p className="leading-6">
                    {messageBody()}
                    <br />
                    <span className="font-semibold">
                        This Action is nonreversible
                    </span>
                </p>

                <div className="flex justify-end mt-6 gap-3">
                    <Button
                        fullWidth={false}
                        size="sm"
                        variant="outline"
                        onClick={close}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth={false}
                        size="sm"
                        color="red"
                        onClick={handleConfirm}
                        loading={loading}
                    >
                        Delete
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default ConfirmDeleteModal;
